/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LocationsStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
